module.exports = __webpack_public_path__ + "img/team-01.37bd9b12.jpg";